<template>
  <div id="header" :style="[headerBg ? {backgroundImage: headerBg} : {backgroundImage: 'radial-gradient(circle farthest-corner at 13% 102%, #3b464e 21%, #080806)'}]">
    <h1>{{headerTitle}}</h1>
  </div>
</template>

<script>
    export default {
        name: "TextHeader",
        props: ['headerTitle', 'headerBg']
    }
</script>

<style scoped>
  #header {
    height: 40vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    background-position: 0 0;
  }

  #header h1 {
    font-family: Roboto, sans-serif;
    font-size: 5.3em;
    line-height: 1.2em;
    text-transform: uppercase;
    color: white;
  }

  @media (max-width: 467px) {
    #header h1 {
      font-size: 2.5em;
    }
  }
</style>
